/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueGtag from "vue-gtag";
import Router from 'vue-router'
import Meta from 'vue-meta'
import store from  '../store'

// Routes
import paths from './paths'
import VueI18Next from "@panter/vue-i18next";
import i18next from "i18next";


function route (path, view, name, requiredAuthority) {
  return {
    name: name || view,
    path,
    component: (resovle) => import(
      `@/views/${view}.vue`
    ).then(resovle),
    beforeEnter: (to, from, next) => {
      store.commit('setErrorMsg','')
      if (requiredAuthority == undefined || requiredAuthority == '') {
        next();
        return;
      }
      if (!store.getters.authorities.includes(requiredAuthority)) {
        next('/');
        return;
      }
      next();
    }
  }
}



Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'hash',
  routes: paths.map(path => route(path.path, path.view, path.name, path.requiredAuthority)).concat([
    { path: '*', redirect: '/' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }

})

Vue.use(Meta)

let useTagManager = false
let useGoogleAnalytics = true

if (useTagManager) {

  Vue.use(VueGtag, {
    config: { id: "GTM-564C5TG" }
  }, router);
}



// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics

if (useGoogleAnalytics) {
  Vue.use(VueAnalytics, {
    id: 'UA-154776000-1', // process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: true //process.env.NODE_ENV !== 'development'
    }
  })
}

export default router
